'use client';

import { ColumnDef } from '@tanstack/react-table';
import type { UserProfile } from '@/graphql/types/admin';
import type { ReactNode } from 'react';

export type UserProfileTable = UserProfile & { actions: ReactNode };

export const usersColumns: ColumnDef<UserProfileTable>[] = [
  {
    accessorKey: 'id',
    header: 'ID',
    size: 200,
    cell: function UserIdCell({ row }: { row: { original: UserProfileTable } }) {
      return <div className="whitespace-normal break-words w-[180px]">{row.original.id}</div>;
    },
  },
  {
    accessorKey: 'display_name',
    header: 'Nome',
    size: 220,
    cell: function UserNameCell({ row }: { row: { original: UserProfileTable } }) {
      return (
        <div className="whitespace-normal break-words w-[200px]">
          {row.original.display_name || row.original.email || '—'}
        </div>
      );
    },
  },
  {
    accessorKey: 'email',
    header: 'Email',
    size: 250,
    cell: function UserEmailCell({ row }: { row: { original: UserProfileTable } }) {
      return <div className="whitespace-normal break-words w-[230px]">{row.original.email}</div>;
    },
  },
  {
    accessorKey: 'plan_name',
    header: 'Plano',
    size: 250,
    cell: function UserPlanCell({ row }: { row: { original: UserProfileTable } }) {
      const planName = row.original.plan?.name || 'Nenhum plano';
      return <div className="whitespace-normal break-words w-[230px]">{planName}</div>;
    },
  },
  {
    accessorKey: 'disabled',
    header: 'Status',
    size: 100,
    cell: function UserStatusCell({ row }: { row: { original: UserProfileTable } }) {
      const isInactive = row.original.disabled === true;
      return (
        <span className="text-sm text-muted-foreground">{isInactive ? 'Inativo' : 'Ativo'}</span>
      );
    },
  },
  {
    accessorKey: 'actions',
    header: '',
    size: 60,
    cell: function ActionsCell({ row }: { row: { original: UserProfileTable } }) {
      return <div className="w-full flex justify-end">{row.original.actions}</div>;
    },
  },
];
